export default '/build/d2b1d114.svg'